import React, { useMemo, useState,useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/TableContainer';
import { getPlan, deletePlan } from "service/api";
import { toast } from "react-toastify";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from "reactstrap";

function DatatableTables({ refresh, onEdit }) {
    const[planList,setPlanList] = useState({ plans: [] });
     const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

   useEffect(() => {
    fetchPlans();
  }, [refresh]);

   const fetchPlans = async () => {
    try {
      const response = await getPlan();
      if (response?.data?.plan) {
        setPlanList({ plans: response.data.plan });
      } else {
        toast.warn("No plans found");
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
      toast.error("Failed to fetch plans");
    }
  };

  const openDeleteModal = (id) => {
    setSelectedDeleteId(id);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setSelectedDeleteId(null);
    setIsDeleteModalOpen(false);
  };

  const confirmDelete = async () => {
    try {
      await deletePlan(selectedDeleteId);
      toast.success("Plan deleted successfully!");
      fetchPlans(); // Refresh after deletion
    } catch (error) {
      toast.error("Failed to delete plan");
      console.error("Error deleting plan:", error);
    } finally {
      closeDeleteModal();
    }
  };

    const columns = useMemo(
        () => [
            {
                Header: 'Plan Name',
                accessor: 'plan',
            },
            {
                Header: "Action",
                Cell: ({ row }) => {
                    const id = row.original._id;
                  return (
                    <>
                    <button
              className="btn btn-primary btn mx-2"
              onClick={() => onEdit(row.original)}
            >
              <i className="mdi mdi-pencil"></i>
            </button>

                      <button className="btn btn-danger mx-2"
                     onClick={() => openDeleteModal(id)}
                    > <i className="mdi mdi-trash-can font-size-15"></i> </button>
                    </>
                  )
                },
              },
        ],
        []
    );
    //meta title
   document.title = "Plan | List";

    return (
        // <div className="page-content">
            <div className="container-fluid mt-3">
            {/* <div className="d-flex justify-content-between align-items-center">
             <h1 className="page-title"></h1>
             <Link to="/add_ward" className="btn btn-primary">ADD NEW WARD</Link>
            </div> */}
                {/* <Breadcrumbs title="Setting" breadcrumbItem="Ward" /> */}
                <TableContainer
                        columns={columns}
                        data={planList.plans}
                        isGlobalFilter={true}
                        isAddOptions={false}  
                        customPageSize={10}
                        className="custom-header-css"
                />
        {/* <DeleteConfirmationModal
          isOpen={isDeleteModalOpen}  
          onClose={closeDeleteModal}
          onConfirm={handleDelete}
        /> */}
        <Modal isOpen={isDeleteModalOpen} toggle={closeDeleteModal} centered>
        <ModalHeader toggle={closeDeleteModal}>Confirm Deletion</ModalHeader>
        <ModalBody>
          Are you sure you want to delete this plan?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={confirmDelete}>Yes, Delete</Button>
          <Button color="secondary" onClick={closeDeleteModal}>Cancel</Button>
        </ModalFooter>
      </Modal>
            </div>
        // </div>
    );
}

export default DatatableTables;